// extracted by mini-css-extract-plugin
module.exports = {"title":"_02712f2b3b--title--mNStg","row":"_02712f2b3b--row--BSQ9s","key":"_02712f2b3b--key--unNVK","value":"_02712f2b3b--value--eDDWO","warning":"_02712f2b3b--warning--ADrBz"};